import React, { useEffect } from "react";
import step1 from "../images/step1.png";
import step2 from "../images/step2.png";
import step3 from "../images/step3.png";
import step4 from "../images/step4.png";

export default function HowToApplyCard() {
  useEffect(() => {
    const initAOS = async () => {
      try {
        const AOS = (await import('https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js')).default;
        if (AOS && typeof AOS.init === 'function') {
          AOS.init({ 
            duration: 800,
            once: true,
            easing: 'ease-out-cubic'
          });
        }
      } catch (error) {
        console.log('AOS loading skipped');
      }
    };
    initAOS();
    
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css';
    document.head.appendChild(link);
  }, []);

  return (
    <div className="relative z-30 w-[80%] max-w-6xl 2xl:max-w-5xl mx-auto -mt-[50%] md:-mt-[-20%]">
      <div className="bg-white rounded-xl px-6 py-10 text-gray-800" data-aos="fade-up">
        <h2 className="text-2xl sm:text-3xl text-center mb-6" data-aos="fade-down" data-aos-delay="100">
          How to apply as <span className="text-[#0E386B] font-bold">Incubatee?</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-xs sm:text-sm">
          {/* STEP 1 */}
          <div className="flex items-start space-x-4" data-aos="fade-right" data-aos-delay="200">
            <img src={step1} alt="Step 1" className="w-12 h-12 mt-1" />
            <div>
              <p className="text-blue-800">STEP 1</p>
              <p className="font-semibold">Click "Apply" and Select Your Cohort</p>
              <p className="text-gray-600">
                Begin by hitting the Apply Now button and choosing which cohort you'd like to join.
                This helps us match you with the right program and timeline.
              </p>
            </div>
          </div>

          {/* STEP 2 */}
          <div className="flex items-start space-x-4" data-aos="fade-left" data-aos-delay="300">
            <img src={step2} alt="Step 2" className="w-12 h-12 mt-1"/>
            <div>
              <p className="text-blue-800">STEP 2</p>
              <p className="font-semibold">Complete the Application Form</p>
              <p className="text-gray-600">
                Fill out the required fields with accurate and up-to-date information. This step ensures we understand your background and readiness for the program.
              </p>
            </div>
          </div>

          {/* STEP 3 */}
          <div className="flex items-start space-x-4" data-aos="fade-right" data-aos-delay="400">
            <img src={step3} alt="Step 3" className="w-12 h-12 mt-1" />
            <div>
              <p className="text-blue-800">STEP 3</p>
              <p className="font-semibold">Review and Confirm Your Details</p>
              <p className="text-gray-600">
                Before submitting, double-check your entries to make sure everything is correct.
                Accuracy helps avoid delays in processing your application.
              </p>
            </div>
          </div>

          {/* STEP 4 */}
          <div className="flex items-start space-x-4" data-aos="fade-left" data-aos-delay="500">
            <img src={step4} alt="Step 4" className="w-12 h-12 mt-1" />
            <div>
              <p className="text-blue-800">STEP 4</p>
              <p className="font-semibold">Application Submitted!</p>
              <p className="text-gray-600">
                You're all set! You can now track your application status anytime through our Status Dashboard.
              </p>
            </div>
          </div>
        </div>

        {/* Help Text */}
        <div className="flex justify-center mt-8">
          <div className="hidden md:block bg-gray-100 text-center px-6 py-3 rounded-full shadow-sm max-w-3xl w-full" data-aos="fade-up" data-aos-delay="600">
            <p className="text-sm text-gray-700">
              If problems persist, please don't hesitate to email us at <strong>tbido@pup.edu.ph</strong> — we're here to help!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}